export const IMAGE_FRAGMENT_BLUR = `
    #define PI 3.1415926538;
    uniform float imageScale;
    uniform float maskScale;
    uniform float opacity;
    uniform sampler2D texture1;
    uniform sampler2D textureOverlay;
    uniform sampler2D mask;
    uniform vec2 resolution;
    uniform vec2 mouse;
    uniform float scaleCenter;
    varying vec2 vUv;
    uniform float darken;

    // Nuevo uniform
    uniform float blurAmount;

    void main() {
        vec2 uMouse = mouse * -0.5;
        uMouse.y *= resolution.y / resolution.x;
        uMouse *= -1.;

        vec2 newUV = (vUv - vec2(scaleCenter)) * resolution.xy + vec2(scaleCenter);
        vec2 mouseUv = vUv + uMouse;
        vec2 newUVMouse = (mouseUv - vec2(scaleCenter)) * resolution.xy + vec2(scaleCenter);

        vec2 textureUVScale = (newUV - scaleCenter) * 1. + scaleCenter;
        vec2 textureUVScaleMouse = (newUVMouse - scaleCenter) * imageScale + scaleCenter;
        vec2 maskUVScale = (newUV - scaleCenter) * maskScale + scaleCenter;

        // --- BLUR IMPLEMENTACIÓN SIMPLE ---
        vec4 blurColor = vec4(0.0); 
        float count = 0.0;
        for(int x = -2; x <= 2; x++) {
            for(int y = -2; y <= 2; y++) {
                vec2 offset = blurAmount * vec2(float(x), float(y)) / resolution;
                blurColor += texture2D(texture1, textureUVScaleMouse + offset);
                count += 1.0;
            }
        }
        blurColor /= count;
        // -----------------------------------

        vec4 textureBlack = texture2D(textureOverlay, textureUVScale);
        vec4 maskColor = texture2D(mask, maskUVScale);

        vec4 darkened = mix(blurColor, textureBlack, darken);

        vec4 maskedColor = darkened * maskColor;
        gl_FragColor = vec4(maskedColor.rgb, maskedColor.a * opacity);
    }

`;


// fragmentShader: [
//  “uniform sampler2D tDiffuse;”,
//  “uniform sampler2D tMask;”,
//  “varying vec2 vUv;”,
// “void main() {“,
//  // get the current pixel color
//  “vec4 texel = texture2D(tDiffuse, vUv);”,
//  // get alpha based on the color of the mask image
//  “float alpha = texture2D(tMask, vUv).r;”,
//  // apply the alpha to the current pixel
//  “gl_FragColor = texel * alpha;”,
//  “}”
// ].join(“\n”)